import React, { useMemo } from "react";
import { Autocomplete } from "components/Autocomplete";
import { AutocompleteRenderInputParams, InputAdornment } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TextField } from "components/TextField";

export interface AttributeCategoryFieldProps {
  categoricalValues: { name: string }[];
  value: string;
  onChangeValue: (value: string) => void;
  errorMessage?: string;
  enableLabel: boolean;
  size: "small" | "medium";
  dense: boolean;
  placeholder?: string;
  inputAdornment: React.ReactNode;
}

export const AttributeCategoryField = ({
  categoricalValues,
  value,
  onChangeValue,
  errorMessage,
  enableLabel,
  size,
  dense,
  placeholder,
  inputAdornment
}: AttributeCategoryFieldProps): JSX.Element => {
  const options = useMemo(() => categoricalValues.map(x => x.name), [
    categoricalValues
  ]);

  return (
    <Autocomplete
      fullWidth
      autoComplete
      autoHighlight
      autoSelect
      disableClearable
      options={options}
      value={value}
      onChange={(_event: React.ChangeEvent<{}>, value: string) =>
        onChangeValue(value)
      }
      placeholder={placeholder}
      data-qa="CM-Category-Attribute-Value"
      renderInput={(params: AutocompleteRenderInputParams) => (
        <CategoryTextField
          {...params}
          size={size ?? "medium"}
          margin={dense ? "dense" : "none"}
          error={Boolean(errorMessage)}
          helperText={errorMessage}
          label={enableLabel ? "Attribute Value" : ""}
          InputProps={{
            ...params.InputProps,
            endAdornment: inputAdornment ? (
              <InputAdornment position="end">{inputAdornment}</InputAdornment>
            ) : null
          }}
          placeholder={placeholder}
        />
      )}
      label={undefined}
      loading={undefined}
      getOptionLabel={undefined}
      error={undefined}
      size={undefined}
    />
  );
};

const CategoryTextField = styled(TextField)`
  & .MuiOutlinedInput-adornedEnd {
    padding-right: 14px !important;
  }
`;
